import { secureApiGet } from '../secureHttp';

export type ScheduleType = 'standard' | 'reschedule_only';

export interface PsychologistWorkSchedulesResponse {
  data: PsychologistWorkSchedule[];
  total: number;
  metadata?: {
    total?: number;
    pages?: number;
    current_page?: number;
    per_page?: number;
    has_next_page?: boolean;
    has_prev_page?: boolean;
  };
}

export interface PsychologistWorkSchedulesQuery extends Record<string, unknown> {
  active?: boolean;
  weekday?: number;
  skip?: number;
  take?: number;
  page?: number;
  per_page?: number;
}

type ApiCoreListResponse<T> = {
  metadata?: {
    total?: number;
    pages?: number;
    current_page?: number;
    per_page?: number;
    has_next_page?: boolean;
    has_prev_page?: boolean;
  };
  results: T[];
};

type ApiCorePsychologistWorkScheduleItem = {
  id: string;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
  psychologist: string | { id?: string };
  weekday: number;
  start_time: string;
  end_time: string;
  active: boolean;
  schedule_type?: string;
};

export type PsychologistWorkSchedule = {
  id: string;
  created_at: string;
  updated_at: string;
  psychologist_id: string;
  weekday: number;
  start_time: string;
  end_time: string;
  active: boolean;
  schedule_type: ScheduleType;
};

export async function getPsychologistWorkSchedules(params?: PsychologistWorkSchedulesQuery): Promise<PsychologistWorkSchedulesResponse> {
  const resp = await secureApiGet<ApiCoreListResponse<ApiCorePsychologistWorkScheduleItem>>(`/v1/psi-platform/psychologist/calendar/work-schedules`, params);
  const items = Array.isArray(resp.results) ? resp.results : [];
  const data: PsychologistWorkSchedule[] = items.map((s) => {
    const psychologistId = typeof s.psychologist === 'string' ? s.psychologist : (s.psychologist?.id ?? '');
    return {
      id: s.id,
      created_at: s.created_at ?? '',
      updated_at: s.updated_at ?? s.created_at ?? '',
      psychologist_id: psychologistId,
      weekday: Number(s.weekday ?? 0),
      start_time: s.start_time,
      end_time: s.end_time,
      active: Boolean(s.active),
      schedule_type: (s.schedule_type === 'reschedule_only' ? 'reschedule_only' : 'standard') as ScheduleType,
    } as PsychologistWorkSchedule;
  });
  const total = resp.metadata?.total ?? data.length;
  return { data, total, metadata: resp.metadata };
}


